'use strict';

var cookie = require('../components/cookie');
var acceptedPrivacyCookie = cookie.getCookie('acceptedPrivacy');
var cookieExpiryTime = require('../utilities/constants').ACCEPTED_PRIVACY_COOKIE_EXPIRY;

module.exports = {
    detectUserAction: function () {
        $(document).on('click keydown', function (e) {
            if (!acceptedPrivacyCookie && (e.key === 'Tab' || e.type === 'click')) {
                cookie.createCookie('acceptedPrivacy', 'true', cookieExpiryTime);
                $('.legal-privacy-banner').addClass('d-none');
            }
        });
    },

    acceptedPrivacy: function () {
        $(window).on('load', function () {
            if (acceptedPrivacyCookie) {
                $('.legal-privacy-banner').addClass('d-none');
            } else {
                $('.legal-privacy-banner').removeClass('d-none');
            }
        });
    }
};